import React from 'react';
import { motion } from 'framer-motion';

// ═══════════════════════════════════════════════════════════════
// BOUNTIFUL SEA (POT) DISPLAY COMPONENT
// ═══════════════════════════════════════════════════════════════

interface BountifulSeaDisplayProps {
  coins: number;
  animateChange?: boolean;
}

export const BountifulSeaDisplay: React.FC<BountifulSeaDisplayProps> = ({
  coins,
  animateChange = false,
}) => {
  return (
    <div className="bs-pot-container">
      <motion.div
        className="bs-pot-display"
        animate={
          animateChange
            ? {
                scale: [1, 1.1, 1],
                boxShadow: [
                  '0 0 30px rgba(42, 123, 123, 0.4), 0 0 20px rgba(212, 175, 55, 0.3)',
                  '0 0 50px rgba(42, 123, 123, 0.6), 0 0 40px rgba(212, 175, 55, 0.5)',
                  '0 0 30px rgba(42, 123, 123, 0.4), 0 0 20px rgba(212, 175, 55, 0.3)',
                ],
              }
            : {}
        }
        transition={{ duration: 0.5 }}
      >
        <span className="bs-pot-label">Bountiful Sea</span>
        <motion.span
          className="bs-pot-coins"
          key={coins}
          initial={{ scale: 1.2, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.3 }}
        >
          {coins}
        </motion.span>
        <span className="bs-pot-coins-label">coins</span>
      </motion.div>
    </div>
  );
};

export default BountifulSeaDisplay;
